import { asyncEpicStandard } from 'src/logic/helpers/epics/async.epic-helper';
import { attachmentDeleteAsync } from './attachment.actions';

export const attachmentDeleteEpic = asyncEpicStandard(
    attachmentDeleteAsync,
    ({ api }, { payload }) => api.attachments.deleteStoredFile(payload.id)
);
